
import GameControl from "../pages/contents/gameControl";

export default [
    {
        path: "/",
        component: GameControl
    },
]